import MessageThreadButton from './MessageThreadButton';

export default MessageThreadButton;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadButton/index.js